/* src/app/layouts/main/main.component.css */
/*# sourceMappingURL=main.component.css.map */
